import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Menu, MenuItem, Typography } from '@mui/material';

import { BLACK, PRIMARY_PURPLE } from '../../../../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../../../../theme/fontConstants';

const menuPaperSx = {
  borderRadius: '8px',
  boxShadow: '0px 4px 16px rgba(0, 0, 51, 0.12)',
};

const menuItemSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1.5,
  minWidth: '200px',
  fontFamily: PRIMARY_FONT[400],
  fontSize: '14px',
  color: BLACK[100],
  py: 1,
  px: 1.5,
};

const menuItemLabelSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  fontFamily: 'inherit',
  fontSize: 'inherit',
};

const menuIconSx = {
  color: PRIMARY_PURPLE[70],
  fontSize: '18px',
};

const DocumentReviewSubmenu = ({
  Icon,
  children,
  isSubmenuOpen,
  labelKey,
  onSubmenuOpen,
  onSubmenuClose,
  showIcon,
  submenuAnchorEl,
}) => (
  <>
    <MenuItem
      onClick={onSubmenuOpen}
      sx={{
        ...menuItemSx,
        ...(isSubmenuOpen && { backgroundColor: PRIMARY_PURPLE[10] }),
        '&:hover': {
          backgroundColor: PRIMARY_PURPLE[10],
        },
      }}
    >
      <Typography component="span" sx={menuItemLabelSx}>
        {showIcon && Icon ? <Icon sx={menuIconSx} /> : null}
        {LanguageConverterV2(labelKey)}
      </Typography>
      <ChevronRightIcon sx={{ color: BLACK[60], fontSize: '18px' }} />
    </MenuItem>
    <Menu
      anchorEl={submenuAnchorEl}
      open={isSubmenuOpen}
      onClose={onSubmenuClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      hideBackdrop
      disableAutoFocus
      disableEnforceFocus
      sx={{ zIndex: 1600 }}
      PaperProps={{ sx: menuPaperSx }}
    >
      {children}
    </Menu>
  </>
);

DocumentReviewSubmenu.propTypes = {
  Icon: PropTypes.elementType,
  children: PropTypes.node,
  isSubmenuOpen: PropTypes.bool,
  labelKey: PropTypes.string.isRequired,
  onSubmenuClose: PropTypes.func,
  onSubmenuOpen: PropTypes.func,
  showIcon: PropTypes.bool,
  submenuAnchorEl: PropTypes.instanceOf(HTMLElement),
};

DocumentReviewSubmenu.defaultProps = {
  Icon: null,
  children: null,
  isSubmenuOpen: false,
  onSubmenuClose: () => {},
  onSubmenuOpen: () => {},
  showIcon: false,
  submenuAnchorEl: null,
};

export default DocumentReviewSubmenu;
